<template>
  <mce-editor v-model="value" />
  <!-- <div>
        <c-search
            :show-drop-down="false"
            :showButton="false"
        >
            <el-form
                :inline="true"
                :model="params"
                label-width="100px"
  
                ref="searchClearForm"
                class="top-computed-ele"
            >
                <el-form-item label=" " class="cearch_btn_wrapper">
                    <el-button
                        class=""
                        @click="handleClear"
                        type="ghost"
                    >清空</el-button>
                    <el-button
                        type="primary"
                        @click="handleSearch"
                    >搜索</el-button>
                </el-form-item>
            </el-form>
        </c-search>
        <div class="g-table-content g-mt-10 g-pr-20 g-pl-20 g-pb-10">
            <c-table-header name="医院终端列表">
                <el-button
                    type="primary"
                    @click="handleAdd"
                ><i class="el-icon-plus el-icon--left"></i>新增</el-button>
                <el-button type="primary"><i class="el-icon-upload2 el-icon--left"></i>导出</el-button>
                <el-button
                    type="primary"
                    @click="handleDel"
                ><i class="el-icon-upload2 el-icon--left"></i>删除</el-button>
            </c-table-header>
            <div class="table">
                <el-table
                    :data="tableData"
                    style="width: 100%"
                    border
                    stripe
                    :max-height="tableHeight"
                    :height="tableHeight"
                    size="mini"
                >

                    <el-table-column
                        label="等级"
                        prop="level"
                    >
                        <template slot-scope="scope">{{showLevel(scope.row.level)}}</template>
                    </el-table-column>
                    <el-table-column
                        prop="username"
                        label="操作"
                        show-overflow-tooltip
                        width="100"
                    >
                        <template slot-scope="scope">
                            <el-button
                                type="text"
                                size="mini"
                                @click="update(scope.row)"
                            >编辑</el-button>
                            <el-button
                                type="text"
                                size="mini"
                                @click="handleDel(scope.row)"
                            >删除</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <page
                class="page-computed__ele"
                :currentPage="pageConfig.currentPage"
                :total="pageConfig.totalResults"
                @sizeChange="handleSizeChange(requestUrl,arguments[0])"
                @currentChange="handleCurrentChange(requestUrl,arguments[0])"
            >
            </page>
        </div>
    </div> -->
</template>
<script>
  import CSearch from '@/components/search-form/index.vue';
  import mceEditor from '@/components/editor/index.vue';
  import computedTableHeight from '@/mixins/computed-table-height.js';
  import createPopup from '@/utils/popup-fun/index.js';
  import add from './demo/add.vue';

  export default {
    componentName: 'tableHeight',
    components: { CSearch, mceEditor },
    mixins: [computedTableHeight],
    data() {
      return {
        value: '',
        // 分页请求url
        requestUrl: '',
        params: {
          // 其他请求列表参数请求参数,必须是params
          rows: 20,
          page: 1
        },
        // 表格数据
        tableData: [],
      };
    },
    computed: {},
    mounted() {
      this.getListData(this.requestUrl, 'commit');
    },
    methods: {
      handleSearch() {
        this.params.page = 1;
        this.getListData(this.requestUrl, 'commit');
      },
      handleClear() { },
      handleAdd() {
        createPopup(add, {}).then(res => {
          alert('你点击了确认箭头');
          // this.getListData(this.requestUrl);
        }).catch(() => {
          alert('取消');
        });
      },
      handleDel() {
        this.handleConfirm('确定要删除吗', { url: '/postUrl', data: { id: 1 } }, (res, success) => {
          if (success) {
            // 删除成功回调
            this.getListData(this.requestUrl);
          } else {
            // 删除失败回调
            this.getListData(this.requestUrl);
          }
        });
      }
    }
  };

</script>
<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/views/demo.vue